import { useMutation } from '@tanstack/react-query';
import { aiService } from '../api/ai.service';
import { aiIdempotencyStore } from '../api/ai.idempotency';
import type { ProposeRequest, QuickTaskProposal } from '../types';

/**
 * Propose mutation for the AI quick-create flow.
 * R1: propose never writes — no setQueryData, no invalidateQueries.
 * On success regenerates the idempotency key so the next apply uses a
 * fresh key per proposal (D6).
 */
/**
 * No cache invalidation on purpose: proposing writes nothing on the server, so there is
 * no cached data to go stale. The write happens in `useApplyQuickTask`, which invalidates.
 */
export function useQuickTaskProposal(projectId: string, boardId: string) {
  return useMutation<QuickTaskProposal, unknown, ProposeRequest>({
    mutationFn: (request) =>
      aiService.proposeQuickTask(
        projectId,
        boardId,
        request.instruction,
        request.boardContext,
        request.timeZoneId,
      ),
    onSuccess: () => {
      aiIdempotencyStore.regenerate(projectId, boardId, 'quick-task');
    },
  });
}
